import React from 'react';
import styled from 'styled-components/macro';

import {
  TYPOGRAPHY_WEIGHT,
  TYPOGRAPHY_TRANSFORM,
  TYPOGRAPHY_ALIGN,
  TYPOGRAPHY_FAMILY,
} from '../types';
import {
  sizesMap,
  fontFamilyMap,
  weightMap,
  textLineHeight,
  textLetterSpacing,
  typographyMarginBottom,
} from '../utils';
import { SIZE } from '../../types';

type ParagraphStyledProps = {
  size: SIZE;
  weight: TYPOGRAPHY_WEIGHT;
  textTransform: TYPOGRAPHY_TRANSFORM;
  align: TYPOGRAPHY_ALIGN;
  familyType: TYPOGRAPHY_FAMILY;
  margin?: 'none';
};

const ParagraphStyled = styled.p<ParagraphStyledProps>`
  font-family: ${(p) => p.theme.fonts[fontFamilyMap[p.familyType]]};
  font-weight: ${(p) => weightMap[p.weight]};
  font-size: ${(p) => sizesMap[p.size].size};
  line-height: ${textLineHeight};
  letter-spacing: ${textLetterSpacing};
  text-transform: ${(p) => p.textTransform};
  text-align: ${(p) => p.align};
  color: ${(p) => p.theme.colors.secondary40w};
  padding: 0;
  margin: ${(p) => typographyMarginBottom(p.margin === 'none')};
`;

type ParagraphPropsBase = {
  size?: SIZE;
  weight?: TYPOGRAPHY_WEIGHT;
  transform?: TYPOGRAPHY_TRANSFORM;
  margin?: 'none';
  align?: TYPOGRAPHY_ALIGN;
  familyType?: TYPOGRAPHY_FAMILY;
  testid?: string;
  style?: React.CSSProperties;
};

type ParagraphProps = ParagraphPropsBase &
  ({ children: React.ReactNode } | { innerHTML: string });

function Paragraph(props: ParagraphProps) {
  const {
    size = 'base',
    weight = 'normal',
    transform = 'none',
    align = 'left',
    familyType = 'serif',
    margin,
    testid,
    style,
  } = props;

  const children = 'children' in props ? props.children : undefined;
  const innerHTML = 'innerHTML' in props ? props.innerHTML : undefined;

  return (
    <ParagraphStyled
      data-testid={testid}
      size={size}
      weight={weight}
      textTransform={transform}
      align={align}
      familyType={familyType}
      margin={margin}
      style={style}
      dangerouslySetInnerHTML={innerHTML ? { __html: innerHTML } : undefined}
    >
      {children}
    </ParagraphStyled>
  );
}

export default React.memo(Paragraph);
